<template>
  <v-dialog v-model="isShow" width="85%" @click:outside="close()">
    <v-card>
      <v-card-title style="text-align: left; padding-bottom: 20px; border-bottom: 1px solid #D2D2D2">
        <div class="d-flex justify-space-between">
          <div style="font-size: 20px; font-weight: bold">
            THÔNG TIN HỌC VIÊN
          </div>
          <v-icon style="font-size: 20px; cursor: pointer" @click="close">mdi-close</v-icon>
        </div>
      </v-card-title>
      <v-card-text style="padding: 0">
        <div style="display: flex">
          <div style="width: 280px; border-right: 1px solid #D2D2D2" class="pa-4">
            <div class="d-flex" style="margin-bottom: 42px">
              <div class="user-profile"></div>
              <div style="width: calc(100% - 84px)">
                <div class="d-flex justify-space-between mb-2">
                  <div style="font-size: 14px; font-weight: bold; line-height: 1.2">{{student.name}}</div>
                  <div>
                    <v-icon color="#4CAF50">mdi-phone</v-icon>
                  </div>
                </div>
                <div style="font-size: 12px; font-weight: bold" class="mb-2">
                  <div style="line-height: 1.3">CID: {{student.customerCode}} - UID: {{studentInfo.id}}</div>
                  <div style="line-height: 1.3">SID: {{student.studentId}}</div>
                </div>
                <div>
                  <div style="font-size: 12px; font-weight: bold; line-height: 1.3; color: #1191E9">{{student.phone}}</div>
                </div>
              </div>
            </div>
            <div class="student-info-form">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="productDetail.name"
                    readonly
                    label="Gói học đăng kí"
                    persistent-placeholder
                    hide-details
                  ></v-text-field>
                </v-col>
                <template v-if="formModel.subjectId === SUBJECT.MATH">
                  <v-col cols="6">
                    <v-select
                      v-model="student.grade"
                      :items="CLASSES"
                      item-text="name"
                      item-value="id"
                      label="Lớp"
                      persistent-placeholder
                      hide-details
                      :readonly="!isClassEditable"
                    >
                      <template v-slot:label>
                        <div class="d-flex justify-space-between" style="width: 145px">
                          Lớp
                          <template v-if="!isClassEditable">
                            <v-tooltip top>
                              <template v-slot:activator="{on}">
                                <v-icon
                                  v-on="on"
                                  style="font-size: 20px; cursor: pointer"
                                  color="#5CC1DB"
                                  @click="handleEditGrade">
                                  mdi-pencil-outline
                                </v-icon>
                              </template>
                              <div>Cập nhật</div>
                            </v-tooltip>
                          </template>
                          <template v-else>
                            <div class="d-flex" style="gap: 6px">
                              <v-tooltip top>
                                <template v-slot:activator="{on}">
                                  <v-icon
                                    v-on="on"
                                    style="font-size: 20px; cursor: pointer"
                                    color="black"
                                    @click="isClassEditable = false; student.grade = currentStudentGrade">
                                    mdi-close
                                  </v-icon>
                                </template>
                                <div>Hủy bỏ</div>
                              </v-tooltip>
                              <v-tooltip top>
                                <template v-slot:activator="{on}">
                                  <v-icon
                                    v-on="on"
                                    style="font-size: 20px; cursor: pointer"
                                    color="#5CC1DB"
                                    @click="handleEditGrade">
                                    mdi-content-save
                                  </v-icon>
                                </template>
                                <div>Cập nhật</div>
                              </v-tooltip>
                            </div>
                          </template>
                        </div>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="student.birthDay"
                      readonly
                      label="Năm sinh"
                      persistent-placeholder
                      hide-details
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      v-model="infoData.bookId"
                      :items="BOOKS"
                      label="Bộ sách"
                      item-value="id"
                      item-text="name"
                      readonly
                      persistent-placeholder
                      hide-details
                    ></v-select>
                  </v-col>
                </template>
                <v-col cols="6">
                  <v-text-field
                    v-model="formModel.regionName"
                    label="Vùng miền"
                    readonly
                    persistent-placeholder
                    hide-details
                  >
                    <template v-slot:append>
                      <div class="region-box" :style="{ color: REGION.find((e) => e.id === formModel.regionId).color}">
                        {{REGION.find((e) => e.id === formModel.regionId).name}}
                      </div>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select
                    :items="listCities"
                    v-model="studentInfo.city.id"
                    label="Tỉnh thành"
                    item-text="name"
                    item-value="id"
                    readonly
                    persistent-placeholder
                    hide-details
                    :title="_.get(_.find(listCities, (e) => e.id === studentInfo.city.id), 'name', '')"
                  >
                  </v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    readonly
                    v-model="formModel.level"
                    :items="computedLevels"
                    item-value="id"
                    item-text="name"
                    label="Trình độ hiện tại"
                    persistent-placeholder
                    hide-details
                  >
                    <template v-slot:append>
                      <v-icon color="#E91E63">mdi-briefcase</v-icon>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    readonly
                    v-model="formModel.subLevel"
                    :items="subLevel"
                    item-text="name"
                    item-value="id"
                    label="Sub level"
                    persistent-placeholder
                    hide-details
                  >
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="formModel.recentLesson"
                    label="Bài học gần đây"
                    persistent-placeholder
                    readonly
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="student.lessionPassedNumber"
                    readonly
                    label="Buổi đã học"
                    persistent-placeholder
                    hide-details
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    readonly
                    v-model="student.totalLessionNumber"
                    label="Tổng số buổi"
                    persistent-placeholder
                    hide-details
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
          </div>
          <div style="width: calc(100% - 280px)">
            <div style="padding: 8px 20px">
              <div style="background: #EFF6FD; padding: 8px" class="mb-2">
                <validation-observer ref="noteForm">
                  <validation-provider rules="required" v-slot="{ errors }" name="Ghi chú">
                    <v-text-field v-model="note" style="margin-top: 0; padding-top: 0px" :error-messages="errors" placeholder="Nhập ghi chú"></v-text-field>
                  </validation-provider>
                </validation-observer>
                <span style="font-size: 12px">Note cuối: {{emptySchedule.lastMessage}}</span>
                <div class="d-flex justify-center">
                  <v-btn small style="border-radius: 24px" color="primary" @click="submitNote">Lưu lại</v-btn>
                </div>
              </div>
              <div style="background: #EFF6FD !important; padding: 8px;" class="d-flex justify-space-between">
                <span style="font-size: 12px; font-weight: bold">
                  CÁC LỚP PHÙ HỢP
                  <span v-if="formModel.recentLesson">(Bài học gần đây: {{formModel.recentLesson}})</span>
                </span>
                <v-btn
                  icon
                  small
                  @click="toggleExpansionPanel"
                >
                  <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </div>
              <v-expansion-panels accordion flat class="custom-expansion" v-model="showedPanel" multiple>
                <v-expansion-panel>
<!--                  <v-expansion-panel-header @click.native.capture.stop="" style="background: #EFF6FD !important; padding: 8px; cursor: default;">-->
<!--                    <template v-slot:actions>-->
<!--                      <v-icon>mdi-menu-down</v-icon>-->
<!--                    </template>-->
<!--                        <span style="font-size: 12px; font-weight: bold">-->
<!--                          CÁC LỚP PHÙ HỢP-->
<!--                          <span v-if="formModel.recentLesson">(Bài học gần đây: {{formModel.recentLesson}})</span>-->
<!--                        </span>-->
<!--                  </v-expansion-panel-header>-->
                  <div class="d-flex justify-space-between mt-1" style="flex-wrap: wrap; gap: 8px">
                    <div class="d-flex" style="gap: 8px">
                      <v-select
                        :items="computedDayOfWeeks"
                        v-model="filterEmptyClass.dayOfWeeks"
                        clearable
                        item-value="id"
                        item-text="name"
                        class="custom-placeholder"
                        style="width: 155px; font-size: 12px"
                        label="Chọn thứ"
                        outlined
                        multiple
                        dense
                        hide-details
                        v-on:input="limiter"
                      />
                      <v-select
                        v-model="filterEmptyClass.caseId"
                        class="custom-placeholder"
                        style="width: 200px; font-size: 14px"
                        label="Giờ học"
                        item-value="id"
                        item-text="name"
                        no-data-text="Không có dữ liệu"
                        :items="dataFilter.cases"
                        outlined
                        clearable
                        multiple
                        dense
                        hide-details
                      >
                        <template v-slot:selection="{ item, index }">
                          <span v-if="index === 0">{{ item.name }}</span>
                          <span
                            v-if="index === 1"
                            class="grey--text text-caption"
                          >
                                (+{{ filterEmptyClass.caseId.length - 1 }} khác)
                              </span>
                        </template>
                      </v-select>
                      <v-select
                        v-if="formModel.subjectId === SUBJECT.MATH"
                        class="custom-placeholder"
                        style="width: 120px; font-size: 12px"
                        label="Khối lớp"
                        item-value="id"
                        item-text="name"
                        no-data-text="Không có dữ liệu"
                        v-model="filterEmptyClass.gradeId"
                        :items="CLASSES"
                        outlined
                        clearable
                        dense
                        hide-details
                      />
                      <v-select
                        class="custom-placeholder"
                        style="width: 140px; font-size: 14px"
                        v-model="formModel.level"
                        :items="computedLevels"
                        item-value="id"
                        item-text="name"
                        label="Level"
                        outlined
                        dense
                        readonly
                        hide-details
                        :title="_.get(_.find(computedLevels, (e) => e.id === formModel.level), 'name', '')"
                      />
                      <v-select
                        v-if="formModel.subjectId === SUBJECT.ENGLISH"
                        class="custom-placeholder"
                        style="width: 110px; font-size: 14px"
                        v-model="formModel.subLevel"
                        label="Sub level"
                        item-text="name"
                        item-value="id"
                        :items="subLevel"
                        outlined
                        dense
                        hide-details
                        readonly
                        :title="_.get(_.find((e) => e.id === formModel.subLevel), 'name', '')"
                      />
                    </div>
                    <div class="d-flex align-center">
                      <span style="margin-right: 12px">Xếp theo</span>
                      <v-select
                        v-model="emptyClassOrder"
                        :items="FILTER_SORT"
                        item-value="id"
                        item-text="name"
                        outlined
                        dense
                        hide-details
                        :title="_.get(_.find(FILTER_SORT ,(e) => e.id === emptyClassOrder), 'name', '')"
                        style="width: 200px; font-size: 14px"
                      />
                    </div>
                  </div>
                  <div class="grade-warning-box" v-if="formModel.subjectId === SUBJECT.MATH && filterEmptyClass.gradeId !== 0 && !filterEmptyClass.gradeId" style="background: #FFF0E7; border: 1px solid rgb(255, 85, 0); padding: 16px; margin: 6px 0">
                    <span style="color: #FF0000">Lưu ý: bắt buộc hỏi lại PHHS lớp của con để tìm kiếm theo Khối lớp</span>
                  </div>
                  <v-expansion-panel-content style="padding: 0px">
                    <v-simple-table class="class-schedule-table" height="400" fixed-header>
                      <template v-slot:default>
                        <thead>
                        <tr style="background: white">
                          <th style="min-width:100px; max-width: 100px">Mã lớp</th>
                          <th style="min-width:150px; max-width: 150px">Lịch học</th>
                          <th class="text-center region-width">Miền</th>
                          <th class="text-center region-width" style="min-width: 80px; max-width: 80px">Sĩ số</th>
                          <th class="text-center" style="min-width: 90px; max-width: 90px">Trạng thái</th>
                          <th class="text-left" style="min-width: 200px; max-width: 200px">Chương trình</th>
                          <th style="min-width: 200px; max-width: 200px">Bài tiếp theo</th>
                          <th class="text-left" style="min-width: 140px; max-width: 140px">Ngày học tiếp theo</th>
                          <th class="text-center sticky-action border-action">Thao tác</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(list, index) in listClassEmpty" :key="'classes' + index">
                          <td>
                            <a style="color: #007AFF; text-decoration: underline; font-weight: 700;">{{list.classCode}}</a>
                          </td>
                          <td>
                            <template v-for="schedules in list.schedules">
                              <div v-for="(schedule, index) in schedules.schedule" class="mt-2 mb-1" :key="'schedule' + index">
                                <div
                                  class="day-of-week align-center mr-2 justify-center"
                                  :style="{
                                    color: schedules.color.color,
                                  }">
                                  <span
                                    v-for="(item, index) in schedule.nameDayOfWeek.split(',')"
                                    :key="'schedule' + index"
                                    :class="filterEmptyClass.dayOfWeeks.includes(DAY_OF_WEEK.find((e) => e.name === item).id) ? 'font-weight-bold' : ''">
                                    {{item}}<span v-if="index < schedule.nameDayOfWeek.split(',').length - 1">,</span>
                                  </span>
                                </div>
                                <div style="min-width: 110px;">
                                  <div v-for="(time, index) in schedule.time.split(',')" :key="'time'+index">
                                    {{time}}
                                  </div>
                                </div>
                              </div>
                            </template>
                          </td>
                          <td class="region-width">
                            <div class="d-flex" style="gap: 6px">
                              <div class="region-box" style="margin: 0 auto;" v-for="(i, index) in list.listTeacher.filter(s => s.region)"
                                   :key="index">
                                <div
                                  :style="{ color: REGION2[i.region].color }"
                                >
                                  {{ REGION2[i.region] ? REGION2[i.region].name : '' }}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td class="text-center region-width" style="color: #EB5757;font-weight:600 ">
                            {{list.totalStudying ? list.totalStudying : '0'}}/{{list.slot ? list.slot : '0'}}
                          </td>
                          <td class="text-center text-no-wrap">
                            {{mapStatusCLass.get(list.status)|| '-'}}
                          </td>
                          <td class="program-width text-left">
                            {{list.programTitle || '-'}}
                            <div v-if="list.programTitle && list.booksTitle" style="color: #0B9154; font-size: 13px;">{{list.booksTitle}}</div>
                          </td>
                          <td class="program-width">{{list.nextLessonTitle || '-'}}</td>

                          <td class="text-left">
                            <strong>{{list.nextLessonDay}}</strong>
                            {{list.nextLessonDate}}
                          </td>
                          <td class="text-center sticky-action border-action">
                            <v-btn
                              width="100"
                              height="24"
                              color="#FF6609"
                              rounded
                              @click="addStudentInClassEmpty(list.id, list.classCode, list.status,list.currentProgramId)"
                              style="text-transform: initial; color: white">
                              Chọn buổi
                            </v-btn>
                            <div v-html="list.lessonStatus"></div>
                          </td>
                        </tr>
                        <!--                            <tr v-if="loading">-->
                        <!--                              <td colspan="9" class="text-center py-4">-->
                        <!--                                <v-progress-circular indeterminate color="primary"></v-progress-circular>-->
                        <!--                              </td>-->
                        <!--                            </tr>-->
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="justify-end d-flex">
        <v-btn small color="#0069C8" style="color: white" @click="openChangeOperatorPopup">Chuyển vận hành</v-btn>
      </v-card-actions>
    </v-card>
    <PopupSelectClassSchedule
      :studentCareInfo="studentCareInfo"
      :dataConfirm="dataConfirm"
      :data="dataTable"
      :isShow="isShowSelectClassSchedule"
      @finish-create-class="finishCreateClass"
      @close="isShowSelectClassSchedule = false"/>
    <v-dialog v-model="isShowChangeOperatorPopup" width="650">
      <ChangeOperatorPopup
        :class-type="ARRANGE_CLASS_TYPE.ONE_N"
        :studentCareInfo="studentCareInfo"
        @finish-change-operator="finishChangeOperator"
        :studentProductId="studentCareInfo.student_product_id"
        @close="isShowChangeOperatorPopup = false"></ChangeOperatorPopup>
    </v-dialog>
  </v-dialog>
</template>

<script>
import ChangeOperatorPopup from '@/modules/student_care/components/ChangeOperatorPopup.vue';
import PopupSelectClassSchedule from '@/components/arrange_class/PopupSelectClassSchedule.vue';
import { mapStatusCLass, REGION } from '@/modules/student_care/constant/constant';
import TutorSortClassRepository from '@/services/TutorSortClassRepository';
import _ from 'lodash';
import moment from 'moment';
import levelSublevel from '@/mixins/levelSublevel';

const ARRANGE_CLASS_TYPE = {
  ONE_ONE: 0,
  ONE_N: 1,
};

const FILTER_SORT_VALUE = {
  1: {
    orderLesson: 'Asc',
  },
  2: {
    orderLesson: 'Desc',
  },
  3: {
    orderDate: 'Asc',
  },
  4: {
    orderDate: 'Desc',
  },
  5: {
    orderSlot: 'Asc',
  },
};
const FILTER_SORT = [
  { id: 1, name: 'Bài tiếp theo tăng dần' },
  { id: 3, name: 'Ngày học tiếp theo tăng dần' },
];
const SUBJECT = {
  MATH: 1,
  ENGLISH: 5,
  LITERATURE: 15,
};
const BOOKS = [
  { id: 3, name: 'Cánh diều', shortName: 'Cánh diều' },
  { id: 4, name: 'Kết nối tri thức cuộc sống', shortName: 'Kết nối' },
  { id: 2, name: 'Chân trời sáng tạo', shortName: 'Chân trời' },
];
const CLASSES = [
  { id: 0, name: 'Lớp <1' },
  { id: 1, name: 'Lớp 1' },
  { id: 2, name: 'Lớp 2' },
  { id: 3, name: 'Lớp 3' },
  { id: 4, name: 'Lớp 4' },
  { id: 5, name: 'Lớp 5' },
  { id: 6, name: 'Lớp 6' },
  { id: 7, name: 'Lớp 7' },
  { id: 8, name: 'Lớp 8' },
  { id: 9, name: 'Lớp 9' },
  { id: 10, name: 'Lớp 10' },
  { id: 11, name: 'Lớp 11' },
  { id: 12, name: 'Lớp 12' },
];
const CLASS_STATUS = {
  LOP_NHAP: 7,
};
const DAY_OF_WEEK = [
  { id: 1, name: 'T2', fullName: 'Thứ 2' },
  { id: 2, name: 'T3', fullName: 'Thứ 3' },
  { id: 3, name: 'T4', fullName: 'Thứ 4' },
  { id: 4, name: 'T5', fullName: 'Thứ 5' },
  { id: 5, name: 'T6', fullName: 'Thứ 6' },
  { id: 6, name: 'T7', fullName: 'Thứ 7' },
  { id: 0, name: 'CN', fullName: 'Chủ nhật' },
];
export default {
  name: 'Arrange1NClassPopup',
  components: { PopupSelectClassSchedule, ChangeOperatorPopup },
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    studentId: {
      type: Number || String,
      required: true,
    },
    studentCareInfo: {
      type: Object,
      required: true,
    },
  },
  mixins: [levelSublevel],
  data() {
    return {
      DAY_OF_WEEK,
      currentStudentGrade: 0,
      emptySchedule: {},
      ARRANGE_CLASS_TYPE,
      isShowChangeOperatorPopup: false,
      emptyClassOrder: 1,
      dataTable: [],
      showedPanel: [0],
      isShowSelectClassSchedule: false,
      CLASS_STATUS,
      mapStatusCLass,
      REGION2: {
        1: {
          name: 'B',
          color: '#219653',
        },
        2: {
          name: 'T',
          color: '#9B51E0',
        },
        3: {
          name: 'N',
          color: '#EB5757',
        },
      },
      isClassEditable: false,
      SUBJECT,
      FILTER_SORT,
      REGION,
      BOOKS,
      CLASSES,
      note: '',
      student: {},
      dataFilter: {},
      productDetail: {},
      formModel: {},
      listCities: [],
      studentInfo: {
        city: {},
      },
      infoData: {},
      listClassEmpty: [],
      filterEmptyClass: {
        dayOfWeeks: [],
        caseType: null,
        caseId: null,
        programId: null,
        lessonId: null,
      },
      classIdSuggesst: null,
      classCodeClass: null,
      dataConfirm: {},
      currentSubjectId: null,
      allSchedule: [],
    };
  },
  async created() {
    await this.getStudentInfo();
    this.getDetailStudent();
    await this.getProductDetail();
    this.getListCities();
    this.getDataFilter();
    this.getListEmptySlotClass();
    this.getLastMessage();
  },
  methods: {
    toggleExpansionPanel() {
      if (this.showedPanel.length === 0) {
        this.showedPanel.push(0);
      } else this.showedPanel = [];
    },
    async handleEditGrade() {
      const currentStatus = this.isClassEditable;
      this.isClassEditable = !this.isClassEditable;
      if (currentStatus) {
        const response = await TutorSortClassRepository.updateStudentClass(this.studentCareInfo.student_product_id, { value: this.student.grade });
        if (response.success) {
          this.$swal({
            text: 'Cập nhật thành công',
            showCancelButton: false,
            icon: 'success',
            timer: 3000,
          });
        } else {
          this.$swal({
            text: `Cập nhật Thất bại !! ${response.message ? ` : ${response.message}` : ''}`,
            showCancelButton: false,
            icon: 'error',
            timer: 3000,
          });
        }
      }
    },
    async submitNote() {
      const isValid = await this.$refs.noteForm.validate();
      if (isValid) {
        const params = {
          calendarType: 1,
          note: this.note,
          studentId: this.studentId,
          items: this.allSchedule,
        };
        const response = await TutorSortClassRepository.updateEmptySchedules(this.studentId, params);
        if (response.message === 'Success') {
          this.note = '';
          this.$refs.noteForm.reset();
          this.$swal({
            icon: 'success',
            text: 'Thêm note thành công !!',
            toast: true,
            position: 'top',
            showCancelButton: false,
            showConfirmButton: false,
            timer: '3000',
          });
          this.getLastMessage();
        } else {
          this.$swal({
            icon: 'error',
            text: 'Có lỗi sảy ra, vui lòng thử lại.',
          });
        }
      }
    },
    async getLastMessage() {
      const result = await TutorSortClassRepository.getEmptySchedules(this.studentId, { calendar_type: 1 });
      if (result.message === 'Success') {
        this.emptySchedule = result.data;
        const selectAll = this.emptySchedule.items.map((item) => {
          const allSchedule = item.items.map((schedule) => {
            // eslint-disable-next-line no-param-reassign
            schedule.calendarStatus = true;
            const body = {
              caseType: item.caseType,
              dayOfWeek: schedule.dayOfWeek,
              calendarStatus: schedule.calendarStatus,
            };
            return body;
          });
          return allSchedule;
        });
        this.allSchedule = selectAll.flat();
      }
    },
    finishCreateClass() {
      Bus.$emit('reload-student-detail-info');
      this.isShowSelectClassSchedule = false;
      this.close();
    },
    finishChangeOperator() {
      this.isShowChangeOperatorPopup = false;
      Bus.$emit('reload-student-detail-info');
      this.close();
    },
    openChangeOperatorPopup() {
      this.isShowChangeOperatorPopup = true;
    },
    async getLesson() {
      const res = await TutorSortClassRepository.getLessonWaiting(this.classIdSuggesst);
      this.dataTable = _.get(res, 'data', []);
      if (this.formModel.subjectId === SUBJECT.ENGLISH) {
        this.dataTable = this.dataTable.filter((e) => e.lessonPosition <= 10);
      }
      this.dataTable = this.dataTable.map((item) => ({
        ...item,
        index: item.lessonTitle + moment(),
      }));
    },
    addStudentInClassEmpty(id, classCode, status, currentProgramId = null) {
      this.classCodeClass = classCode;
      this.dataConfirm = {
        id,
        classCode,
        status,
        currentProgramId,
        studentProductId: this.studentCareInfo.student_product_id,
      };
      this.classIdSuggesst = id;
      this.getLesson();
      this.isShowSelectClassSchedule = true;
    },
    async getListEmptySlotClass(classType = null, dataFilter = {}) {
      const tempDataFilter = _.cloneDeep(dataFilter);
      if (tempDataFilter.gradeId) {
        // eslint-disable-next-line no-param-reassign
        tempDataFilter.gradeId = [tempDataFilter.gradeId];
      }
      let params = {
        level: this.formModel && this.infoData.level ? [this.infoData.level.id] : [-1],
        classType: this.infoData?.classType ? [this.infoData.classType] : null,
        studentId: this.studentId,
        curriculumId: this.infoData?.curriculumId,
        availableClass: true,
        ...FILTER_SORT_VALUE[this.emptyClassOrder],
      };
      if (classType) {
        params.classType = [classType];
      }
      const subjectId = this.subjectId || this.infoData?.subject?.id;
      if (subjectId === SUBJECT.ENGLISH) {
        params.teacherType = [this.infoData.teacherType];
      }
      if (!_.isEmpty(tempDataFilter)) {
        params = {
          ...params,
          ...tempDataFilter,
        };
      }
      if (this.formModel.subLevel && this.formModel.subjectId === SUBJECT.ENGLISH) {
        params.subLevels = [this.formModel.subLevel];
      }
      if (tempDataFilter.level) {
        params.level = [tempDataFilter.level];
      }
      params.bookId = 'all';
      const res = await TutorSortClassRepository.getListEmptySlotClass(this.infoData?.subject?.id, params);
      this.listClassEmpty = _.get(res, 'data', []);
      if (this.formModel.subjectId === SUBJECT.ENGLISH) {
        this.listClassEmpty = this.listClassEmpty.filter((e) => e.lessonOrder.order <= 10 && e.nextLessonDate !== null);
      } else if (this.formModel.subjectId === SUBJECT.MATH && this.filterEmptyClass.gradeId !== 0 && !this.filterEmptyClass.gradeId) {
        this.listClassEmpty = [];
      }
      this.listClassEmpty = this.listClassEmpty.filter((e) => e.status !== CLASS_STATUS.LOP_NHAP).map((item) => {
        const lists = item.schedules.map((schedules) => {
          const schedule = schedules.schedule.map((s) => ({
            ...s,
            nameDayOfWeek: s.day,
          }));
          return {
            ...schedules,
            schedule,
          };
        });
        return {
          ...item,
          schedules: lists,
          startAt: item.startDate,
        };
      });
    },
    limiter(e) {
      if (e.length > 2) {
        e.pop();
      }
    },
    async getListCities() {
      try {
        const params = {
          regionId: this.formModel.regionId,
        };
        const responses = await TutorSortClassRepository.getListCities(params);
        this.listCities = responses.data;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.$emit('close');
    },
    async getProductDetail() {
      const res = await TutorSortClassRepository.getListProduct(this.studentId);
      if (res.success) {
        this.productDetail = res.data.find((e) => e.productId === this.studentCareInfo.student_product_id);
        await this.getInfoClass();
      }
    },
    async getInfoClass() {
      const responses = await TutorSortClassRepository.getInfoClass(this.studentId, this.studentCareInfo.student_product_id);
      this.infoData = responses.data;
      if (this.infoData.subject == null) {
        this.infoData.subject = {};
        this.infoData.subject.name = '';
      }
      if (this.infoData.grade == null) {
        this.infoData.grade = {};
        this.infoData.grade.id = '';
      }
      if (this.infoData.level == null) {
        this.infoData.level = {};
        this.infoData.level.name = '';
        this.infoData.level.id = '';
      }
    },
    async getDetailStudent() {
      const loader = this.$loading.show();
      const response = await TutorSortClassRepository.getDetailStudent(
        this.studentId,
      );
      loader.hide();
      this.studentInfo = response.data;
      if (!this.studentInfo.region) {
        this.studentInfo.region = {
          id: null,
        };
      }
      if (!this.studentInfo.city) {
        this.studentInfo.city = {
          id: null,
        };
      }
      if (!this.studentInfo.district) {
        this.studentInfo.district = {
          id: null,
        };
      }
      this.studentInfo.birthDay = moment(this.studentInfo.birthDay, 'DD-MM-YYYY').format('YYYY-MM-DD') || null;
    },
    async getDataFilter() {
      const res = await TutorSortClassRepository.getDataFilter(this.formModel.subjectId, this.formModel.classType);
      if (res.success) {
        this.dataFilter = res.data;
      }
    },
    async getStudentInfo() {
      const res = await TutorSortClassRepository.getStudentInfo(this.studentCareInfo.student_product_id);
      if (res.success) {
        this.student = _.cloneDeep(_.get(res, 'data[0]', {}));
        this.currentStudentGrade = this.student.grade;
        this.formModel.curriculumId = _.get(res, 'data[0].curriculum.id');
        this.formModel.subjectId = _.get(res, 'data[0].subject.id');
        this.formModel.teacherType = _.get(res, 'data[0].teacherType.id');
        this.formModel.classType = _.get(res, 'data[0].classType.id');
        this.formModel.regionId = _.get(res, 'data[0].region.id');
        this.formModel.regionName = _.get(res, 'data[0].region.name');
        this.formModel.level = _.get(res, 'data[0].level.id');
        this.formModel.subLevel = _.get(res, 'data[0].subLevel.id');
        this.formModel.recentLesson = _.get(res, 'data[0].recentLesson');
        this.currentSubjectId = this.formModel.subjectId;
      }
    },
  },
  watch: {
    emptyClassOrder() {
      this.getListEmptySlotClass(null, this.filterEmptyClass);
    },
    filterEmptyClass: {
      handler(val) {
        this.getListEmptySlotClass(null, val);
      },
      deep: true,
    },
  },
  computed: {
    computedDayOfWeeks() {
      let result = [];
      if (this.dataFilter.dayOfWeeks) {
        result = _.cloneDeep(this.dataFilter.dayOfWeeks);
        result.forEach((e) => {
          if (e.id === 0) {
            e.name = 'CN';
          }
        });
      }
      return result;
    },
    computedLevels() {
      if (this.currentSubjectId === SUBJECT.MATH) {
        return this.levelDefault;
      }
      if (this.currentSubjectId === SUBJECT.ENGLISH) {
        return this.levelEnglish;
      }
      return [];
    },
  },
};
</script>

<style scoped>
.student-info-form .v-input{
  font-size: 13px !important;
}
.region-box {
  font-size: 12px !important;
  padding: 3px 5px;
  color: green;
}
.sticky-action {
  position: sticky;
  right: -1px!important;
  z-index: 1;
}
.grade-warning-box {
  position: relative;
}
.grade-warning-box::before {
  content: '';
  width: 20px;
  height: 20px;
  position: absolute;
  top: -11px;
  left: 440px;
  transform: rotate(45deg);
  background: rgb(255, 240, 231);
  border-left: 1px solid rgb(255, 85, 0);
  border-top: 1px solid rgb(255, 85, 0);
}
</style>

<style lang="scss">
.class-schedule-table {
  thead {
    tr {
      th {
        background: #EFF6FD !important;
        font-size: 12px !important;
        font-weight: bold;
      }
    }
  }
}
.custom-expansion .v-expansion-panel-content__wrap {
  padding: 0px;
  padding-top: 4px;
}
.custom-expansion .v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 48px;
}
.user-profile {
  position: relative;
  height: 72px;
  width: 72px;
  border-radius: 50%;
  background: #079697;
  margin-right: 12px;
}
.custom-placeholder input::placeholder {
  font-size: 14px !important;
}
.border-action {
  border-left: 1px solid #cccccc;
  background: #fff;
}
</style>
